
import missions from '~/mixins/pages/mission-control/missions'
export default {
    name: 'Theme2MissionMobileRoadmapLayoutsTypeOne',
    mixins: [missions],
    props: {
        missionActivities: {
            type: Array,
            default: () => {},
        },
        missionId: {
            type: String,
            default: '',
        },
        eventType: {
            type: String,
            default: '',
        },
        extraCoin: {
            type: Number,
            default: 0,
        },
        extraCoinStatus: {
            type: Number,
            default: 0,
        },
    },
}
